import script from "./InspectionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InspectionsView.vue?vue&type=script&setup=true&lang=ts"

import "./InspectionsView.vue?vue&type=style&index=0&id=f1096542&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1096542"]])

export default __exports__